// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .Kx6BWZLuR5OUj9kRQypC{
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
    padding-right: 4px;
  }
  .dtUg628oog4g6j0rlLID {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 20px;
  }
  .WA0JAbvVsyAHofL30bP5 {
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: -0.078px;
    color: rgb(var(--placeholder-primary))
  }
  .M6a1O3OsUsYGAwbpSoe8 {
    font-size: 13px;
    font-style: normal;
    font-weight: 590;
    line-height: 18px; /* 138.462% */
    letter-spacing: -0.078px;
    color: rgb(var(--placeholder-primary))
  }
  .ADD830t_rMSV6vi163tf {
    display: flex;
    flex-direction: row;
    gap: 1px;
    align-items: center;
    transition: color ease-in-out 0.2s;
  }
  .ADD830t_rMSV6vi163tf:hover{
    color: rgb(var(--placeholder-primary))
  }

  .WrYaWw7Nm9E2MsPWa6Wu{
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
    margin: 0 auto 0;
  }
  .BQuzs3OGFhZd0FLf71cK {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    align-items: center;
    justify-items: start;
    gap: 5px;
    margin-bottom: 20px;
  }
  
  .o8lruFKnRUzckN2TN4dM {
    display: flex;
    flex-direction: row;
    justify-content: end;
    align-items: center;
    gap: 5px;
    margin-bottom: 20px;
  }
  
  
  .CGE4GlZYL5836FbJWiek {
    color: #1c77ff;
    font-size: 16.5px;
    font-weight: 540;
    letter-spacing: 0.43px;
    padding: 0;
    background: transparent;
    cursor: pointer;
    border: none;
    transition: color 0.3s ease 0s;
  }
  
  .CGE4GlZYL5836FbJWiek:hover {
    color: #055ada;
    background: transparent;
  }
  
  .kMPDq1LqMeRQTa9Jnqrn {
    font-size: 17px;
    font-weight: 760;
    letter-spacing: 0.43px;
    line-height: 129.41%;
    margin: 0 auto;
  }
  .IJsMkaWPQMnZXRwUrGjU {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 6px;
    margin-top: 16px;
  }
  
  .TZyh9CjMa_mbakUfT7xJ {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  
  .RJG2QVQ29GnuZ7wce_d1 {
    position: absolute;
    right: 50%;
    top: 50%;
    z-index: 50;
    transform: translate(50%, -50%);
  }
  .adNXaqBX1vPsthZPWoLa {
    cursor: pointer;
    padding: 10px;
    border-radius: 50%;
    background: rgb(var(--accent-brand));
    border: 3px solid rgb(var(--secondary-bg));

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .adNXaqBX1vPsthZPWoLa:active {
    outline: 1px solid rgb(var(--placeholder-tertiary));
  }

  /* .swapButtonWrapper:hover {
    outline: 1px solid rgb(var(--placeholder-tertiary));
  }
   */
  .TxuGAuWZhsyH0ZbNUYST {
    padding: 14px 21px;
    font-style: 17px;
    font-weight: 540;
    line-height: 129%;
    border-radius: 30px;
    background: #007AFF;
    letter-spacing: 0.63px;
    width: 100%;
    height: auto;
  }
  
  .TxuGAuWZhsyH0ZbNUYST:hover {
    background: #007AFF;
  }
  
  .LSgoA_oloq_g3DFozELA {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  
  .jhscEak2OWSg6GsXFdH6 {
    font-weight: 540;
  }
  
  .leGt2OgrZsXTXQ9UlfOg {
    margin: 20px 0;
  }
  .mTOBzEqhzG5dZLemPV_a {
    margin-bottom: 15px;
    font-size: 20px;
    font-weight: 760;
    line-height: 120%;
  }
  .Sg34TLMkUyTpAwkyo0Kl {
    padding: 13px;
    font-size: 17px;
    width: 100%;
    border-radius: 10px;
    background: rgba(118, 118, 128, 0.12);
    border: none;
    color: rgba(60, 60, 67, 0.6);
    margin-bottom: 20px;
  }
  

/* info block */
.z6wv0hBU5J9mnIiygFEY {
  padding: 16px;
  background: rgba(var(--secondary-bg), 0.60);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 8px;
  border-radius: 24px;
  border: 1px solid rgba(var(--border), 0.20);
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px); 
}

.FJqFbImYN6e8bB4uFLsv {
  display: flex;
  align-items: center;
  justify-content: center;
}

.FJqFbImYN6e8bB4uFLsv > svg {
  height: 2px;
  width: 100%;
}

.w7xJdQE7AqyXut1zJwFW {
  color: rgb(var(--placeholder-secondary));
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.07px;
}

.nKpKZon0CYUXLTy1qifw {
  color: rgb(var(--placeholder-primary));
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.5px;
}
.gHdVjUh9MBwWAEYBuAGK {
  display: flex;
  width: 100%;
  gap: 3px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.Xkb5yOG4uDB2i32YM13L {
  width: 90%;
  margin: 15px auto 3px; 
  /* text-align: justify; */
  font-size: 13px;

  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 138.462% */
  letter-spacing: -0.078px;
}

.ZtmZSp2oHaHnDS23R447 {
  width: 14px;
  height: 14px;
}

/* error block */
.jmcPG5zzoQIaQj685bj3 {
  padding: 16px;
  background: rgba(var(--secondary-bg), 0.60);
  display: flex;
  border-radius: 24px;
  border: 1px solid rgba(var(--border), 0.20);
  backdrop-filter: blur(40px);
  -webkit-backdrop-filter: blur(40px); 
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 3px;
  margin-bottom: 32px;
}

.Hz3UE7MQjOKv6nUd1gxg {
  color: #FF3B30;
}
.sPuUNroff_iXzCHPm3JA {
  width: 25px;
  height: 25px;
}

/* switch animation */

.PVYSTZ6RTAEq8SQUVWVs > svg {
  transform: rotate(180deg);
  s: transform 0.3s ease;
}

@keyframes LG_X4Xihc8Tp37dV9hwf {
  0% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

.PcOAXcvwy8ZFqEDVkVzv > svg {
  animation: LG_X4Xihc8Tp37dV9hwf 0.3s ease;
}`, "",{"version":3,"sources":["webpack://./src/pages/swap/amounts/amounts.module.css"],"names":[],"mappings":"EAAE;IACE,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB;EACF;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,aAAa;IAChC,wBAAwB;IACxB;EACF;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,kCAAkC;EACpC;EACA;IACE;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,qCAAqC;IACrC,mBAAmB;IACnB,oBAAoB;IACpB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;EACrB;;;EAGA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,UAAU;IACV,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,8BAA8B;EAChC;;EAEA;IACE,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,oBAAoB;IACpB,cAAc;EAChB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,WAAW;IACX,+BAA+B;EACjC;EACA;IACE,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,oCAAoC;IACpC,0CAA0C;;IAE1C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,mDAAmD;EACrD;;EAEA;;;IAGE;EACF;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,qCAAqC;IACrC,YAAY;IACZ,4BAA4B;IAC5B,mBAAmB;EACrB;;;AAGF,eAAe;AACf;EACE,aAAa;EACb,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,QAAQ;EACR,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,WAAW;EACX,QAAQ;EACR,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;;EAEf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,2BAA2B;EAC3B,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,qBAAqB;;AAErB;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,yCAAoC;AACtC","sourcesContent":["  .wrapper{\n    display: flex;\n    justify-content: space-between;\n    flex-direction: column;\n    height: 100%;\n    overflow-y: auto;\n    padding-right: 4px;\n  }\n  .bottomWrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-top: 20px;\n  }\n  .poweredText {\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 18px;\n    letter-spacing: -0.078px;\n    color: rgb(var(--placeholder-primary))\n  }\n  .poweredTextBold {\n    font-size: 13px;\n    font-style: normal;\n    font-weight: 590;\n    line-height: 18px; /* 138.462% */\n    letter-spacing: -0.078px;\n    color: rgb(var(--placeholder-primary))\n  }\n  .dedustLink {\n    display: flex;\n    flex-direction: row;\n    gap: 1px;\n    align-items: center;\n    transition: color ease-in-out 0.2s;\n  }\n  .dedustLink:hover{\n    color: rgb(var(--placeholder-primary))\n  }\n\n  .poweredWrapper{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 4px;\n    margin: 0 auto 0;\n  }\n  .modalTop {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    align-items: center;\n    justify-items: start;\n    gap: 5px;\n    margin-bottom: 20px;\n  }\n  \n  .modalTopRight {\n    display: flex;\n    flex-direction: row;\n    justify-content: end;\n    align-items: center;\n    gap: 5px;\n    margin-bottom: 20px;\n  }\n  \n  \n  .modalTopButton {\n    color: #1c77ff;\n    font-size: 16.5px;\n    font-weight: 540;\n    letter-spacing: 0.43px;\n    padding: 0;\n    background: transparent;\n    cursor: pointer;\n    border: none;\n    transition: color 0.3s ease 0s;\n  }\n  \n  .modalTopButton:hover {\n    color: #055ada;\n    background: transparent;\n  }\n  \n  .modalTitle {\n    font-size: 17px;\n    font-weight: 760;\n    letter-spacing: 0.43px;\n    line-height: 129.41%;\n    margin: 0 auto;\n  }\n  .modalColumn {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    gap: 6px;\n    margin-top: 16px;\n  }\n  \n  .modalContent {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n  \n  .modalContentSwap {\n    position: absolute;\n    right: 50%;\n    top: 50%;\n    z-index: 50;\n    transform: translate(50%, -50%);\n  }\n  .swapButtonWrapper {\n    cursor: pointer;\n    padding: 10px;\n    border-radius: 50%;\n    background: rgb(var(--accent-brand));\n    border: 3px solid rgb(var(--secondary-bg));\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .swapButtonWrapper:active {\n    outline: 1px solid rgb(var(--placeholder-tertiary));\n  }\n\n  /* .swapButtonWrapper:hover {\n    outline: 1px solid rgb(var(--placeholder-tertiary));\n  }\n   */\n  .button {\n    padding: 14px 21px;\n    font-style: 17px;\n    font-weight: 540;\n    line-height: 129%;\n    border-radius: 30px;\n    background: #007AFF;\n    letter-spacing: 0.63px;\n    width: 100%;\n    height: auto;\n  }\n  \n  .button:hover {\n    background: #007AFF;\n  }\n  \n  .container {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n  }\n  \n  .modalContentMain {\n    font-weight: 540;\n  }\n  \n  .passwordBlock {\n    margin: 20px 0;\n  }\n  .passwordLabel {\n    margin-bottom: 15px;\n    font-size: 20px;\n    font-weight: 760;\n    line-height: 120%;\n  }\n  .passwordInput {\n    padding: 13px;\n    font-size: 17px;\n    width: 100%;\n    border-radius: 10px;\n    background: rgba(118, 118, 128, 0.12);\n    border: none;\n    color: rgba(60, 60, 67, 0.6);\n    margin-bottom: 20px;\n  }\n  \n\n/* info block */\n.infoWrapper {\n  padding: 16px;\n  background: rgba(var(--secondary-bg), 0.60);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  gap: 8px;\n  border-radius: 24px;\n  border: 1px solid rgba(var(--border), 0.20);\n  backdrop-filter: blur(40px);\n  -webkit-backdrop-filter: blur(40px); \n}\n\n.dottedLine {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.dottedLine > svg {\n  height: 2px;\n  width: 100%;\n}\n\n.hintText {\n  color: rgb(var(--placeholder-secondary));\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  letter-spacing: -0.07px;\n}\n\n.ordinaryText {\n  color: rgb(var(--placeholder-primary));\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: -0.5px;\n}\n.infoRow {\n  display: flex;\n  width: 100%;\n  gap: 3px;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.description {\n  width: 90%;\n  margin: 15px auto 3px; \n  /* text-align: justify; */\n  font-size: 13px;\n\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px; /* 138.462% */\n  letter-spacing: -0.078px;\n}\n\n.smallSpinner {\n  width: 14px;\n  height: 14px;\n}\n\n/* error block */\n.errorWrapper {\n  padding: 16px;\n  background: rgba(var(--secondary-bg), 0.60);\n  display: flex;\n  border-radius: 24px;\n  border: 1px solid rgba(var(--border), 0.20);\n  backdrop-filter: blur(40px);\n  -webkit-backdrop-filter: blur(40px); \n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 3px;\n  margin-bottom: 32px;\n}\n\n.errorText {\n  color: #FF3B30;\n}\n.alertWrapper {\n  width: 25px;\n  height: 25px;\n}\n\n/* switch animation */\n\n.switcherUp > svg {\n  transform: rotate(180deg);\n  s: transform 0.3s ease;\n}\n\n@keyframes switchAnimation {\n  0% {\n    transform: rotate(180deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n\n.switcherDown > svg {\n  animation: switchAnimation 0.3s ease;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Kx6BWZLuR5OUj9kRQypC`,
	"bottomWrapper": `dtUg628oog4g6j0rlLID`,
	"poweredText": `WA0JAbvVsyAHofL30bP5`,
	"poweredTextBold": `M6a1O3OsUsYGAwbpSoe8`,
	"dedustLink": `ADD830t_rMSV6vi163tf`,
	"poweredWrapper": `WrYaWw7Nm9E2MsPWa6Wu`,
	"modalTop": `BQuzs3OGFhZd0FLf71cK`,
	"modalTopRight": `o8lruFKnRUzckN2TN4dM`,
	"modalTopButton": `CGE4GlZYL5836FbJWiek`,
	"modalTitle": `kMPDq1LqMeRQTa9Jnqrn`,
	"modalColumn": `IJsMkaWPQMnZXRwUrGjU`,
	"modalContent": `TZyh9CjMa_mbakUfT7xJ`,
	"modalContentSwap": `RJG2QVQ29GnuZ7wce_d1`,
	"swapButtonWrapper": `adNXaqBX1vPsthZPWoLa`,
	"button": `TxuGAuWZhsyH0ZbNUYST`,
	"container": `LSgoA_oloq_g3DFozELA`,
	"modalContentMain": `jhscEak2OWSg6GsXFdH6`,
	"passwordBlock": `leGt2OgrZsXTXQ9UlfOg`,
	"passwordLabel": `mTOBzEqhzG5dZLemPV_a`,
	"passwordInput": `Sg34TLMkUyTpAwkyo0Kl`,
	"infoWrapper": `z6wv0hBU5J9mnIiygFEY`,
	"dottedLine": `FJqFbImYN6e8bB4uFLsv`,
	"hintText": `w7xJdQE7AqyXut1zJwFW`,
	"ordinaryText": `nKpKZon0CYUXLTy1qifw`,
	"infoRow": `gHdVjUh9MBwWAEYBuAGK`,
	"description": `Xkb5yOG4uDB2i32YM13L`,
	"smallSpinner": `ZtmZSp2oHaHnDS23R447`,
	"errorWrapper": `jmcPG5zzoQIaQj685bj3`,
	"errorText": `Hz3UE7MQjOKv6nUd1gxg`,
	"alertWrapper": `sPuUNroff_iXzCHPm3JA`,
	"switcherUp": `PVYSTZ6RTAEq8SQUVWVs`,
	"switcherDown": `PcOAXcvwy8ZFqEDVkVzv`,
	"switchAnimation": `LG_X4Xihc8Tp37dV9hwf`
};
export default ___CSS_LOADER_EXPORT___;
